import * as angular from 'angular';
import 'angular-ui-router';
import BuilderObservabilityView from './builderObservabilityView.html';
import { BuilderObservabilityController } from './builderObservabilityController';
import { builderObservabilityScriptSource } from 'app.constants';
import { MicroFrontendService } from 'modules/shared/MicroFrontendService';
export const builderObservabilityStateName = 'auth.application.detail.builderObservability';
export const builderObservabilityUnitTestStateName = 'auth.application.detail.builderObservability.unit-test';
export const builderObservabilityMonitoringStateName = 'auth.application.detail.builderObservability.builder-monitoring';
export const builderObservabilityAnyStateName = 'auth.application.detail.builderObservability.any';
export const builderObservability = angular
    .module('builderObservability', ['ui.router', 'shared', 'app.constants'])
    .config(['$stateProvider', ($stateProvider) => {
        const studioFeatureEnabledResolve = {
            checkLayout: [
                'StudioService',
                (studioService) => studioService.shouldEnableStudioFeatures(),
            ],
        };
        $stateProvider
            .state(builderObservabilityStateName, {
            url: '/builder-observability',
            resolve: studioFeatureEnabledResolve,
            views: {
                'content@auth.application.detail': {
                    template: BuilderObservabilityView,
                    controller: BuilderObservabilityController,
                    controllerAs: '$ctrl',
                },
            },
            onEnter: [
                'SegmentService',
                'CurrentApplicationService',
                async (segmentService, currentApplicationService) => {
                    const application = await currentApplicationService.fetchApplication();
                    await segmentService.createApplicationTrack({
                        trackEvent: 'unit-tests-and-logs-clicked',
                        application,
                    });
                    return MicroFrontendService.addSource(builderObservabilityScriptSource);
                },
            ],
        })
            .state(builderObservabilityUnitTestStateName, {
            url: '/unit-test',
            resolve: studioFeatureEnabledResolve,
        })
            .state(builderObservabilityMonitoringStateName, {
            url: '/builder-monitoring',
            resolve: studioFeatureEnabledResolve,
        })
            .state(builderObservabilityAnyStateName, {
            url: '/{path:any}',
            resolve: studioFeatureEnabledResolve,
        });
    }]).name;
